async function switchToSubscription(event, itemKey, itemId) {
  try {
    await upgradeToSubs(event.target, itemKey, itemId);
  } catch (error) {
    console.error("Failed to parse bundleItem or call switchToSubscription:", error);
  } finally {
    setTimeout(() => {
      renderStarterKitLineItems();
    }, 2000);
  }
}

async function renderBundleSetLineItems() {
  let items;
  if (window.Rebuy && Rebuy.Cart && Rebuy.Cart.status == "ready" && Rebuy.Cart.cart) {
    items = Rebuy.Cart.cart.items;
  } else {
    let cart = await fetchCart();
    items = cart.items;
  }
  const bundlesInCart = {};
  let cartPageItemsNode = document.querySelector(cartItemsSelector);
  const bundleLineItems = document.querySelectorAll(".static-line-item-bundle-set-ctn");
  bundleLineItems.forEach((item) => item.remove());

  // Group items by _bundle_id
  items.forEach((item) => {
    const bundleId = item.properties["_bundle_set"];
    if (bundleId) {
      if (!bundlesInCart[bundleId]) {
        bundlesInCart[bundleId] = [];
      }
      bundlesInCart[bundleId].push(item);
    }
  });

  // Render each bundle
  Object.entries(bundlesInCart).forEach(([bundleId, bundleItems]) => {
    // console.log(bundleItems, "BUNDLE ITEMS");
    let bundleLineItemQty = document.createElement("div");
    bundleLineItemQty.id = bundleId;
    bundleLineItemQty.classList.add("line-item", "rebuy-cart__flyout-item", "static-line-item", "static-line-item-bundle-set-qty");
    bundleLineItemQty.dataset.type = "_bundle_set";

    const config = {
      showQty: false,
      showQtyChange: false,
      showQtyRemove: false,
      showPrice: true,
    };

    // **1. Sort bundleItems to have "Diffuser" product first**
    bundleItems.sort((a, b) => {
      const isDiffuserA = a.product_type === "Diffuser" ? -1 : 1;
      const isDiffuserB = b.product_type === "Diffuser" ? -1 : 1;
      return isDiffuserA - isDiffuserB;
    });

    let bundleMarkup = document.createElement(isCartPage ? "tr" : "li");
    bundleMarkup.id = bundleId;
    bundleMarkup.classList.add("line-item", "static-line-item", "rebuy-cart__flyout-item", "static-line-item-bundle-set-ctn");
    bundleMarkup.dataset.type = "_bundle_set";
    // Create the bundle title
    const bundleTitle = document.createElement("h3");
    bundleTitle.classList.add("bundle-set-cart-title");
    bundleTitle.textContent = `${bundleItems[0].product_title} Bundle Set includes:`;
    bundleMarkup.appendChild(bundleTitle);

    bundleItems.forEach((item, index) => {
      let newBundleLineItem = document.createElement("div");
      newBundleLineItem.id = bundleId;
      newBundleLineItem.classList.add("line-item", "rebuy-cart__flyout-item", "static-line-item-bundle-set");

      const isLastItem = index === bundleItems.length - 1; // Determine if this is the last item

      if (isCartPage) {
        newBundleLineItem.innerHTML = bundleSetLineItemMarkupCartPage(item, index, config, isLastItem);
      } else {
        newBundleLineItem.innerHTML = bundleSetItemMarkup(item, index, config, isLastItem);
      }

      bundleMarkup.appendChild(newBundleLineItem);
    });

    // Create and append quantity buttons
    bundleLineItemQty.innerHTML = isCartPage ? bundleQtyButtonsCartPage(bundleItems[0]) : bundleQtyButtons(bundleItems[0]);

    bundleMarkup.appendChild(bundleLineItemQty);

    // Check if the bundle item already exists, if not, append it
    const addedBundleItem = document.querySelector(`.static-line-item-bundle-set-ctn[id="${bundleId}"]`);
    if (!addedBundleItem) {
      cartPageItemsNode.appendChild(bundleMarkup);
    }
  });

  setTimeout(() => {
    attachELToLineItem();
  }, 1500);
}

function bundleQtyButtons(item) {
  const bundleQty = item.quantity;
  return `
    <div class="state-line-item-quantity">
      <div class="rebuy-cart__flyout-item-quantity">
      <h4>Quantity</h4>
      <div class="rebuy-cart__flyout-item-quantity-widget">
        <button
          alt="Decrease quantity"
          aria-label="Decrease quantity of"
          type="button"
          class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-decrease quantity-selector__button-dec">
          <i aria-hidden="true" class="far fa-minus"></i>
        </button>
        <span class="rebuy-cart__flyout-item-quantity-widget-label quantity-selector__input">
          ${bundleQty}
        </span>
        <button
          alt="Increase quantity"
          aria-label="Increase quantity"
          type="button"
          class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-increase quantity-selector__button-inc">
          <i aria-hidden="true" class="far fa-plus"></i>
        </button>
      </div>
    </div>
      <button
      type="button"
      alt="Remove"
      aria-label="Remove"
      class="line-item__remove-button text-underline">
      Remove Set
    </button>
    </div>
  `;
}

function bundleQtyButtonsCartPage(item) {
  const bundleQty = item.quantity;
  return `
    <div class="state-line-item-quantity">
      <div class="rebuy-cart__flyout-item-quantity">
      <h4>Quantity</h4>
      <line-item-quantity style="display: block; margin-top: -4px">
      <div class="quantity-selector quantity-selector--small">
        <a href="javascript:void(0)" class="quantity-selector__button quantity-selector__button-dec" aria-label="Decrease quantity" data-no-instant="">
        <svg focusable="false" width="8" height="2" class="icon icon--minus   " viewBox="0 0 8 2">
          <path fill="currentColor" d="M0 0h8v2H0z"></path>
        </svg>
        </a>
        <span is="input-number" class="quantity-selector__input text--xsmall" autocomplete="off" type="text" inputmode="numeric" name="updates[]" data-line="1" size="2" aria-label="Change quantity" data-gaconnector-tracked="true">${bundleQty}</span>
        <a href="javascript:void(0)" class="quantity-selector__button quantity-selector__button-inc" aria-label="Increase quantity" data-no-instant="">
        <svg focusable="false" width="8" height="8" class="icon icon--plus   " viewBox="0 0 8 8">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M3 5v3h2V5h3V3H5V0H3v3H0v2h3z" fill="currentColor"></path>
        </svg>
        </a>
      </div>
      <a href="javascript:void(0)" class="line-item__remove-button link text--subdued text--xsmall" data-no-instant="">Remove Set</a>
      </line-item-quantity>
    </div>
    </div>
  `;
}

function bundleSetItemMarkup(item, index, config) {
  //console.log(item, typeof item, index, config, item.properties, item.id, item.title, "ITEM");
  const itemTitle = item.product_title;
  const itemVariantTitle = item?.variant_title || "";
  const compareAtProp = item.properties["_compare_at_price"];
  const rebuyCap = item?.product?.selected_variant?.compare_at_price;
  const compareAtPrice = rebuyCap && typeof rebuyCap == "string" ? parseFloat(rebuyCap) * 100 : rebuyCap && typeof rebuyCap == "number" ? rebuyCap : null;
  const itemSlashedOutPrice = compareAtProp && compareAtProp !== "0" ? parseFloat(compareAtProp) : IS_US && compareAtPrice ? compareAtPrice : item.original_price || 0;

  const itemSalePrice = item.final_price;
  const itemOffValue = Math.round(((itemSlashedOutPrice - itemSalePrice) / itemSlashedOutPrice) * 100);
  const itemImg = item.image;
  const itemUrl = item.url || "";

  return `
          <div class="rebuy-cart__flyout-item-media">
            <a href="${itemUrl}" tabindex="-1">
              <img src="${itemImg}" alt="${itemTitle}">
            </a>
          </div>
          <div class="rebuy-cart__flyout-item-info">
            <a
              role="heading"
              aria-level="5"
              href="${itemUrl}"
              alt="View ${itemTitle}"
              class="rebuy-cart__flyout-item-product-title">${itemTitle}</a>
              
            ${item.quantity > 1 ? `<div class="rebuy-cart__flyout-item-variant-qty" style="color: #535353; font-size: 12px;">Quantity: ${item.quantity}</div>` : ``}
            <div class="rebuy-cart__flyout-item-variant-title">${itemVariantTitle.replace(/Pro-Pod™\s*\/\s*30mL/g, "Pro-Pod™")}</div>
            ${itemOffValue > 0 ? `<div class="rebuy-cart__flyout-item-discount-message">Save ${itemOffValue}%</div>` : ``}
             <div class="rebuy-cart__flyout-item-properties" style="margin: 0;">
              ${item.selling_plan_allocation
      ? `<p style="margin: 0;font-size: 12px;" class="rebuy-cart__flyout-item-property-value">
                  ${item.selling_plan_allocation.selling_plan.name.replace("Delivered every 90 days.", "Delivered every 90 days.")}</p>`
      : item.properties["_source"] !== "Rebuy" && item.product?.selling_plan_groups?.length
        ? `<button
                      type="button"
                      style="display: block;background: none; border: none; padding: 0; margin: 3px 0; text-decoration: underline; color: #000; font-size: 13px; cursor: pointer;"
                      class="rebuy-cart__flyout-item-switch-button"
                      onclick="switchToSubscription(event, '${item.key}', '${item.id})'">
                      Upgrade to Subscribe & Save
                  </button>`
        : ``
    }
             </div>
            <div class="rebuy-cart__flyout-item-price">
              <div>
                <span class="rebuy-money sale">
                  <span class="sr-only">Sale price</span>
                  <span>${formatMoney(itemSalePrice)}</span>
                </span>
                ${itemSlashedOutPrice && itemSlashedOutPrice != "0" && itemSlashedOutPrice > itemSalePrice
      ? `
                  <span class="rebuy-money compare-at">
                  <span class="sr-only">Original price</span>
                  <span>${formatMoney(itemSlashedOutPrice)}</span>
                </span>
                  `
      : ``
    }
              </div>
            </div>
          </div>
      `;
}

function bundleSetLineItemMarkupCartPage(item, index, config, isLastItem) {
  const itemTitle = item.product_title;
  const itemVariantTitle = item?.variant_title || "";
  const itemSlashedOutPrice =
    item.properties["_compare_at_price"] && item.properties["_compare_at_price"] !== "0" ? item.properties["_compare_at_price"] : item.original_price || 0;

  const itemSalePrice = item.final_price;
  const itemOffValue = Math.round(((itemSlashedOutPrice - itemSalePrice) / itemSlashedOutPrice) * 100);
  const itemImg = item.image;
  const itemUrl = item.url || "";

  return `
		<td class="md:w-1/12 pt-7 pb-0 md:pt-5 md:pb-5 col-start-1 col-end-1 align-top">
			<div class="relative w-full md:w-32 float-left before:h-0 before:block before:pb-[100%]">
				<a href="${itemUrl}" class="absolute top-0 left-0 disable-effect w-full h-full overflow-hidden bg-[#f5f1ec] rounded-md" aria-label="Item added to your cart" tabindex="-1">
					<img src="${itemImg}" class="object-cover h-full w-full top-0 left-0 absolute duration-300 image-hover z-0" alt="${itemTitle}" loading="lazy" width="150" height="150">
				</a>
			</div>
		</td>
		<td class="md:w-5/12 pt-7 pb-0 px-5 md:pt-5 md:pb-5 lg:pl-9 lg:pr-14 col-start-2 col-end-5 md:col-end-4 align-top">
			<div>
				<a href="${itemUrl}" class="text-[rgba(var(--colors-heading))] font-bold table disable-effect hover-text-link p-break-words mb-1.5">
					${itemTitle}
				</a>
			</div>
			<dl class="text-normal pb-1.5">
				${itemVariantTitle ? `<dd class="rebuy-cart__flyout-item-variant-title">${itemVariantTitle.replace(/Pro-Pod™\s*\/\s*30mL/g, "Pro-Pod™")}</dd>` : ''}
				${item.quantity > 1 ? `<dd class="rebuy-cart__flyout-item-variant-qty" style="color: #535353; font-size: 12px;">Quantity: ${item.quantity}</dd>` : ''}
			</dl>
			${item.selling_plan_allocation ? `<p class="text-normal pb-1.5">${item.selling_plan_allocation.selling_plan.name.replace("Delivered every 90 days.", "Delivered every 90 days.")}</p>` : ''}
			${item.properties["_source"] !== "Rebuy" && item.product?.selling_plan_groups?.length ? `
				<button type="button" style="display: block;background: none; border: none; padding: 0; margin: 3px 0; text-decoration: underline; color: #000; font-size: 13px; cursor: pointer;" class="rebuy-cart__flyout-item-switch-button" onclick="switchToSubscription(event, '${item.key}', '${item.id}')">
					Upgrade to Subscribe & Save
				</button>
			` : ''}
			<div class="price mb-1.5 md:hidden">
				${itemSlashedOutPrice > itemSalePrice ? `<s class="cap mr-1 rtl:ml-1 rtl:mr-0 inline-block opacity-50 text-[#1a1a1a]">${formatMoney(itemSlashedOutPrice)}</s>` : ''}
				<span class="selection:bg-text-[rgb(var(--colors-price-sale),0.2)] text-[#6b2e16] font-semibold">
					${formatMoney(itemSalePrice)}
				</span>
			</div>
			${itemOffValue > 0 ? `
			<ul class="w-fit p-1 bg-[#6b2e16] lg:mb-0 rounded-md mt-2">
				<li class="flex text-white relative x-discount items-center gap-2">
					<span class="leading-none text-normal discount-title">${itemOffValue}% Off on Sale</span>
				</li>
			</ul>
			` : ''}
		</td>
		<td class="lg:pl-2 pt-0 pb-5 pl-5 mt-2 md:pr-5 lg:pr-0 md:mt-3.5 md:pl-0 md:pt-5 rtl:pr-5 rtl:md:pr-0 rtl:md:pl-5 rtl:lg:pl-0 col-start-2 col-end-4 flex items-center md:table-cell md:align-top">
		</td>
		<td class="pb-5 md:pt-5 md:table-cell md:align-top lg:w-2/12 lg:pl-2">
			<div class="flex justify-end">
				<div class="price cart-item-price-1 hidden md:flex md:flex-wrap md:flex-col text-right">
					${itemSlashedOutPrice > itemSalePrice ? `<s class="cap mr-1 rtl:ml-1 rtl:mr-0 inline-block opacity-50 text-[#1a1a1a]">${formatMoney(itemSlashedOutPrice)}</s>` : ''}
					<span class="text-[#6b2e16] font-semibold">${formatMoney(itemSalePrice)}</span>
				</div>
			</div>
		</td>
   `;
}

async function renderStarterKitLineItems() {
  console.log("renderStarterKitLineItems");
  let items;
  if (window.Rebuy && Rebuy.Cart && Rebuy.Cart.status == "ready" && Rebuy.Cart.cart) {
    items = Rebuy.Cart.cart.items;
  } else {
    let cart = await fetchCart();
    items = cart.items;
  }
  const bundlesInCart = {};
  let cartPageItemsNode = document.querySelector(cartItemsSelector);
  const bundleLineItems = document.querySelectorAll(".static-line-item-starter-kit");
  bundleLineItems.forEach((item) => item.remove());

  // Group items by _bundle_id
  items.forEach((item) => {
    const bundleId = item.properties["_bundle_id"];
    if (bundleId) {
      if (!bundlesInCart[bundleId]) {
        bundlesInCart[bundleId] = [];
      }
      bundlesInCart[bundleId].push(item);
    }
  });

  // Render each bundle
  Object.entries(bundlesInCart).forEach(([bundleId, bundleItems]) => {
    let newBundleLineItem = document.createElement(isCartPage ? "tr" : "li");
    newBundleLineItem.id = bundleId;
    newBundleLineItem.classList.add("line-item", "rebuy-cart__flyout-item", "static-line-item", "static-line-item-starter-kit");
    newBundleLineItem.dataset.type = "_bundle_id";

    if (isCartPage) {
      newBundleLineItem.innerHTML = starterKitLineItemMarkupCartPage(bundleItems);
    } else {
      newBundleLineItem.innerHTML = startKitBundleItemMarkup(bundleItems);
    }

    const addedBundleItem = document.getElementById(bundleId);
    if (!addedBundleItem) {
      cartPageItemsNode.append(newBundleLineItem);
    }
  });
  setTimeout(() => {
    attachELToLineItem();
  }, 2000);
}

function startKitBundleItemMarkup(bundleItems) {
  let mainBundleItem = bundleItems.find((item) => item.product_type == "Diffuser" || item.product_type == "Hourglass Diffuser");
  let fpTitle = mainBundleItem?.product_title || "Bundle";
  const fpVariantTitle = mainBundleItem?.variant_title || "";
  const fpSlashedOutPrice = bundleItems.reduce(
    (sum, bundleItem) =>
      sum +
      parseFloat(
        bundleItem.properties["_compare_at_price"] && bundleItem.properties["_compare_at_price"] !== "0"
          ? bundleItem.properties["_compare_at_price"]
          : bundleItem.original_price || 0
      ),
    0
  );
  if (!mainBundleItem) mainBundleItem = bundleItems[0];
  const isStarterKitBundle = mainBundleItem?.properties["_starter_kit_bundle"];
  const isBundle = mainBundleItem?.properties["_source"] === "Rebuy" || mainBundleItem?.properties["_bundle_title"]
  fpTitle = isBundle && mainBundleItem.properties["_bundle_title"] ? mainBundleItem.properties["_bundle_title"] : fpTitle;

  const fpSalePrice = bundleItems.reduce((sum, bundleItem) => sum + bundleItem.final_price, 0);
  const fpOffValue = Math.round(((fpSlashedOutPrice - fpSalePrice) / fpSlashedOutPrice) * 100);
  const fpImg = isBundle || isStarterKitBundle ? mainBundleItem.properties["_bundle_image_url"] : mainBundleItem?.image || "";
  const fpUrl = mainBundleItem?.url || "";
  const bundleQty = mainBundleItem.quantity;
  const discountValue = fpSlashedOutPrice > fpSalePrice ? ((fpSlashedOutPrice - fpSalePrice) / fpSlashedOutPrice) * 100 : 0;
  const bundleSaleMsg = false && (discountValue > 0 ? `Save ${Math.round(discountValue)}% w/ Oil Bundle` : "");
  const bundleSetMsg = mainBundleItem.properties["_bundle_set_message"] || "";

  function fpProductsTitleProp() {
    let string = "";
    bundleItems.forEach((bundleItem) => {
      if (isBundle || (bundleItem.product_type != "Diffuser" && bundleItem.product_type != "Hourglass Diffuser")) {
        string += `
        <div class="rebuy-cart__flyout-item-member">
          <div class="rebuy-cart__flyout-item-property">
           ${!isStarterKitBundle ? `
            <span class="rebuy-cart__flyout-item-property-name">${bundleItem.product_type}</span>
            <span class="rebuy-cart__flyout-item-property-separator"> - </span>` : ``}
            <span class="rebuy-cart__flyout-item-property-value">${bundleItem.title.replace(/Pro-Pod™\s*\/\s*30mL/g, "Pro-Pod™")}</span>
            <span class="rebuy-cart__flyout-item-property-value">x ${bundleItem.quantity}</span>
            ${
              bundleItem.selling_plan_allocation
                ? `<p style="margin: 0;font-size: 12px;" class="rebuy-cart__flyout-item-property-value">${bundleItem.selling_plan_allocation.selling_plan.name.replace(
                    "Delivered every 90 days.",
                    "3-month supply, delivered quarterly"
                  )}</p>`
                : bundleItem.properties["_source"] !== "Rebuy" &&
                  bundleItem.product?.selling_plan_groups?.length &&
                  (bundleItem.properties["_bundle_subs_upgrade"] === undefined || bundleItem.properties["_bundle_subs_upgrade"])
                ? `<button 
                    type="button" 
                    style="display: block;background: none; border: none; padding: 0; margin: 3px 0; text-decoration: underline; color: #000; font-size: 13px; cursor: pointer;" 
                    class="rebuy-cart__flyout-item-switch-button" 
                    onclick="switchToSubscription(event, '${bundleItem.key}', '${bundleItem.id}')">
                    Upgrade to Subscribe & Save
                 </button>`
                : ``
            }
          </div>
        </div>`;
      }
    });
    return string;
  }

  return `
          <div class="rebuy-cart__flyout-item-media">
            <a href="${fpUrl}" tabindex="-1">
              <img src="${fpImg}" alt="${fpTitle}">
            </a>
          </div>
          <div class="rebuy-cart__flyout-item-info">
            <a
              role="heading"
              aria-level="5"
              href="${fpUrl}"
              alt="View ${fpTitle}"
              class="rebuy-cart__flyout-item-product-title">${fpTitle}</a>
            <div class="rebuy-cart__flyout-item-variant-title">${fpVariantTitle}</div>
            ${bundleSaleMsg ? `<div class="rebuy-cart__flyout-item-discount-message">${bundleSaleMsg}</div>` : ``}
            ${bundleSetMsg ? `<div class="rebuy-cart__flyout-item-bundle-set-message" style="margin-bottom: 4px;">Bundle - ${bundleSetMsg}</div>` : ``}
            
            <div class="rebuy-cart__flyout-item-properties">
              ${fpProductsTitleProp(bundleItems)}
            </div>
            <button
              type="button"
              alt="Remove ${fpTitle}"
              aria-label="Remove ${fpTitle}"
              class="rebuy-cart__flyout-item-remove line-item__remove-button">
              <i aria-hidden="true" class="far fa-trash"></i>
            </button>
            <div class="rebuy-cart__flyout-item-quantity">
              <div class="rebuy-cart__flyout-item-quantity-widget">
                <button
                  alt="Decrease quantity of ${fpTitle}"
                  aria-label="Decrease quantity of ${fpTitle}"
                  type="button"
                  class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-decrease quantity-selector__button-dec">
                  <i aria-hidden="true" class="far fa-minus"></i>
                </button>
                <span class="rebuy-cart__flyout-item-quantity-widget-label quantity-selector__input">
                  ${bundleQty}
                </span>
                <button
                  alt="Increase quantity of ${fpTitle}"
                  aria-label="Increase quantity of ${fpTitle}"
                  type="button"
                  class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-increase quantity-selector__button-inc">
                  <i aria-hidden="true" class="far fa-plus"></i>
                </button>
              </div>
            </div>
            <div class="rebuy-cart__flyout-item-price">
              <div>
                <span class="rebuy-money ${fpSlashedOutPrice > fpSalePrice ? 'sale' : ''}">
                  <span class="sr-only">Sale price</span>
                  <span>${formatMoney(fpSalePrice)}</span>
                </span>
                ${
                  fpSlashedOutPrice && fpSlashedOutPrice != "0" && fpSlashedOutPrice > fpSalePrice
                    ? `
                  <span class="rebuy-money compare-at">
                  <span class="sr-only">Original price</span>
                  <span>${formatMoney(fpSlashedOutPrice)}</span>
                </span>
                  `
                    : ``
                }
              </div>
            </div>
          </div>
      `;
}

function starterKitLineItemMarkupCartPage(bundleItems) {
  let mainBundleItem = bundleItems.find((item) => item.product_type == "Diffuser" || item.product_type == "Hourglass Diffuser");
  let bundleTitle = mainBundleItem?.product_title || "Bundle";
  const bundleVariantTitle = mainBundleItem?.variant_title || "";
  const bundleSlashedOutPrice = bundleItems.reduce(
    (sum, bundleItem) =>
      sum +
      parseFloat(
        bundleItem.properties["_compare_at_price"] && bundleItem.properties["_compare_at_price"] !== "0"
          ? bundleItem.properties["_compare_at_price"]
          : bundleItem.original_price || 0
      ),
    0
  );
  if (!mainBundleItem) mainBundleItem = bundleItems[0];
  const isStarterKitBundle = mainBundleItem?.properties["_starter_kit_bundle"];
  const isBundle = mainBundleItem?.properties["_source"] === "Rebuy" || mainBundleItem?.properties["_bundle_title"];
  bundleTitle = isBundle && mainBundleItem.properties["_bundle_title"] ? mainBundleItem.properties["_bundle_title"] : bundleTitle;

  const bundleSalePrice = bundleItems.reduce((sum, bundleItem) => sum + bundleItem.final_price, 0);
  const bundleOffValue = Math.round(((bundleSlashedOutPrice - bundleSalePrice) / bundleSlashedOutPrice) * 100);
  const bundleImg = isBundle || isStarterKitBundle ? mainBundleItem.properties["_bundle_image_url"] : mainBundleItem?.image || "";
  const bundleUrl = mainBundleItem?.url || "";
  const bundleQty = bundleItems[0].quantity;

  function bundleProductsTitleProp() {
    let string = "";
    bundleItems.forEach((bundleItem) => {
      if (isBundle || (bundleItem.product_type != "Diffuser" && bundleItem.product_type != "Hourglass Diffuser")) {
        string += `
        <div class="rebuy-cart__flyout-item-member">
          <div class="rebuy-cart__flyout-item-property">
           ${!isStarterKitBundle
            ? `
            <span class="rebuy-cart__flyout-item-property-name">${bundleItem.product_type}</span>
            <span class="rebuy-cart__flyout-item-property-separator"> - </span>
            `
            : ``
          }
            <span class="rebuy-cart__flyout-item-property-value">${bundleItem.title.replace(/Pro-Pod™\s*\/\s*30mL/g, "Pro-Pod™")}</span>
            <span class="rebuy-cart__flyout-item-property-value">x ${bundleItem.quantity}</span>
            ${bundleItem.selling_plan_allocation
            ? `<p style="margin: 0;font-size: 12px;" class="rebuy-cart__flyout-item-property-value">${bundleItem.selling_plan_allocation.selling_plan.name.replace(
              "Delivered every 90 days.",
              "3-month supply, delivered quarterly"
            )}</p>`
            : bundleItem.properties["_source"] !== "Rebuy" &&
              bundleItem.product?.selling_plan_groups?.length &&
              (bundleItem.properties["_bundle_subs_upgrade"] === undefined || bundleItem.properties["_bundle_subs_upgrade"])
              ? `<button 
                    type="button" 
                    style="display: block;background: none; border: none; padding: 0; margin: 3px 0; text-decoration: underline; color: #000; font-size: 13px; cursor: pointer;" 
                    class="rebuy-cart__flyout-item-switch-button" 
                    onclick="switchToSubscription(event, '${bundleItem.key}', '${bundleItem.id}')">
                    Upgrade to Subscribe & Save
                 </button>`
              : ``
          }
          </div>
        </div>`;
      }
    });
    return string;
  }

  return `
		<td class="md:w-1/12 pt-7 pb-0 md:pt-5 md:pb-5 col-start-1 col-end-1 align-top">
			<div class="relative w-full md:w-32 float-left before:h-0 before:block before:pb-[100%]">
				<a href="${bundleUrl}" class="absolute top-0 left-0 disable-effect w-full h-full overflow-hidden bg-[#f5f1ec] rounded-md" aria-label="Item added to your cart" tabindex="-1">
					<img src="${bundleImg}" class="object-cover h-full w-full top-0 left-0 absolute duration-300 image-hover z-0" alt="${bundleTitle}" loading="lazy" width="150" height="150">
				</a>
			</div>
		</td>
		<td class="md:w-5/12 pt-7 pb-0 px-5 md:pt-5 md:pb-5 lg:pl-9 lg:pr-14 col-start-2 col-end-5 md:col-end-4 align-top">
			<div>
				<a href="${bundleUrl}" class="text-[rgba(var(--colors-heading))] font-bold table disable-effect hover-text-link p-break-words mb-1.5">
					${bundleTitle}
				</a>
			</div>
			<dl class="text-normal pb-1.5">
				${bundleVariantTitle ? `<dd class="rebuy-cart__flyout-item-variant-title">${bundleVariantTitle}</dd>` : ''}
			</dl>
			<div class="rebuy-cart__flyout-item-properties">
				${bundleProductsTitleProp()}
			</div>
			<div class="price mb-1.5 md:hidden">
				${bundleSlashedOutPrice > bundleSalePrice ? `<s class="cap mr-1 rtl:ml-1 rtl:mr-0 inline-block opacity-50 text-[#1a1a1a]">${formatMoney(bundleSlashedOutPrice)}</s>` : ''}
				<span class="selection:bg-text-[rgb(var(--colors-price-sale),0.2)] text-[#6b2e16] font-semibold">
					${formatMoney(bundleSalePrice)}
				</span>
			</div>
			${bundleOffValue > 0 ? `
			<ul class="w-fit p-1 bg-[#6b2e16] lg:mb-0 rounded-md mt-2">
				<li class="flex text-white relative x-discount items-center gap-2">
					<span class="leading-none text-normal discount-title">${bundleOffValue}% Off on Sale</span>
				</li>
			</ul>
			` : ''}
		</td>
		<td class="lg:pl-2 pt-0 pb-5 pl-5 mt-2 md:pr-5 lg:pr-0 md:mt-3.5 md:pl-0 md:pt-5 rtl:pr-5 rtl:md:pr-0 rtl:md:pl-5 rtl:lg:pl-0 col-start-2 col-end-4 flex items-center md:table-cell md:align-top">
			<div class="x-cart-item-quantity flex justify-center">
				<div class="flex flex-row md:flex-col items-center gap-2">
					<div class="relative flex w-28 h-10 border border-solid justify-between rounded-full">
						<button class="items-center w-1/3 justify-center flex opacity-70 cursor-pointer quantity-selector__button-dec quantity-button-decrease" aria-label="button-minus" data-no-instant="">
							<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="w-3" fill="none" viewBox="0 0 10 2">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
							</svg>
						</button>
						<span class="cart-item-qty outer-spin-button bg-transparent w-1/3 text-center pt-2 pb-2 placeholder:opacity-60 focus-within:outline-none quantity-selector__input" aria-label="Quantity for ${bundleTitle}">${bundleQty}</span>
						<button class="items-center w-1/3 justify-center flex opacity-70 cursor-pointer quantity-selector__button-inc quantity-button-increase" aria-label="button-plus" data-no-instant="">
							<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="w-3" fill="none" viewBox="0 0 10 10">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
							</svg>
						</button>
					</div>
				</div>
			</div>
		</td>
		<td class="pb-5 md:pt-5 md:table-cell md:align-top lg:w-2/12 lg:pl-2">
			<div class="flex justify-end">
				<div class="price cart-item-price-1 hidden md:flex md:flex-wrap md:flex-col text-right">
					${bundleSlashedOutPrice && bundleSlashedOutPrice != "0" && bundleSlashedOutPrice > bundleSalePrice ? `<s class="cap mr-1 rtl:ml-1 rtl:mr-0 inline-block opacity-50 text-[#1a1a1a]">${formatMoney(bundleSlashedOutPrice)}</s>` : ''}
					<span class="text-[#6b2e16] font-semibold">${formatMoney(bundleSalePrice)}</span>
				</div>
			</div>
		</td>
   `;
}

// Bundles and Family Plan
async function renderBundleLineItems() {
  let items;
  if (window.Rebuy && Rebuy.Cart && Rebuy.Cart.status == "ready" && Rebuy.Cart.cart) {
    items = Rebuy.Cart.cart.items;
  } else {
    let cart = await fetchCart();
    items = cart.items;
  }
  const bundlesInCart = [];
  let CartPageItemsNode = document.querySelector(cartItemsSelector);
  const bundleLineItems = CartPageItemsNode.querySelectorAll(".static-line-item-bundle");
  bundleLineItems.forEach((item) => {
    item.remove();
  });
  items.map((item) => {
    const bundleCodeProp = item.properties["_bundle_hash"];
    if (bundleCodeProp) {
      if (!bundlesInCart.includes(bundleCodeProp)) {
        //run this block only for first item is the bundle
        bundlesInCart.push(bundleCodeProp);
        let newBundleLineItem = document.createElement("li");
        if (isCartPage) {
          newBundleLineItem = document.createElement("tr");
        }
        newBundleLineItem.id = bundleCodeProp;
        newBundleLineItem.dataset.type = "_bundle_hash";
        newBundleLineItem.classList.add("line-item", "rebuy-cart__flyout-item", "static-line-item", "static-line-item-bundle");
        if (isCartPage) {
          newBundleLineItem.innerHTML = bundleLineItemMarkupCartPage(item);
        } else {
          newBundleLineItem.innerHTML = bundleLineItemMarkup(item);
        }
        const addedBundleItem = document.getElementById(`${bundleCodeProp}`);
        if (!addedBundleItem) {
          CartPageItemsNode.append(newBundleLineItem);
        }
      }
    }
  });
  setTimeout(() => {
    attachELToLineItem();
  }, 2000);
}

async function renderFpLineItems() {
  let items;
  if (window.Rebuy && Rebuy.Cart && Rebuy.Cart.status == "ready" && Rebuy.Cart.cart) {
    items = Rebuy.Cart.cart.items;
  } else {
    let cart = await fetchCart();
    items = cart.items;
  }
  const bundlesInCart = [];
  let cartPageItemsNode = document.querySelector(cartItemsSelector);
  const bundleLineItems = cartPageItemsNode.querySelectorAll(".static-line-item-fp");
  bundleLineItems.forEach((item) => {
    item.remove();
  });
  items.map((item) => {
    const fpCodeProp = item.properties["_fp_id"];
    if (fpCodeProp) {
      if (!bundlesInCart.includes(fpCodeProp)) {
        bundlesInCart.push(fpCodeProp);
        let newBundleLineItem = document.createElement("li");
        if (isCartPage) {
          newBundleLineItem = document.createElement("tr");
        }
        newBundleLineItem.id = fpCodeProp;
        newBundleLineItem.classList.add("line-item", "rebuy-cart__flyout-item", "static-line-item", "static-line-item-fp");
        newBundleLineItem.dataset.type = "_fp_id";
        if (isCartPage) {
          newBundleLineItem.innerHTML = fpLineItemMarkupCartPage(item);
        } else {
          newBundleLineItem.innerHTML = fpLineItemMarkup(item);
        }
        const addedBundleItem = document.getElementById(`${fpCodeProp}`);
        if (!addedBundleItem) {
          cartPageItemsNode.append(newBundleLineItem);
        }
      }
    }
  });
  setTimeout(() => {
    attachELToLineItem();
  }, 2000);
}

function fpLineItemMarkupCartPage(item) {
  const fpTitle = "Family Plan";
  const fpSlashedOutPrice = item.properties["_fp_slashed_out_price"];
  const fpSalePrice = item.properties["_fp_sale_price"];
  let fpOffValue = item.properties["_fp_off_value"];
  const fpImg = item.properties["_fp_img"];
  const fpUrl = item.properties["_fp_url"];

  function fpProductsTitleProp(item) {
    let string = "";

    if (item.properties["_fq_products"]) {
      item.properties["_fq_products"].forEach((productGroup, index) => {
        string += `
			<div class="rebuy-cart__flyout-item-member">
			  <h4>Member ${index + 1}</h4>
			  <div class="rebuy-cart__flyout-item-property">
				<span class="rebuy-cart__flyout-item-property-name">Diffuser</span>
				<span class="rebuy-cart__flyout-item-property-separator"> - </span>
				<span class="rebuy-cart__flyout-item-property-value">${productGroup.product_title}</span>
			  </div>
			  <div class="rebuy-cart__flyout-item-property">
				<span class="rebuy-cart__flyout-item-property-name">Oil</span>
				<span class="rebuy-cart__flyout-item-property-separator"> - </span>
				<span class="rebuy-cart__flyout-item-property-value">${productGroup.addon_title.replace(/Pro-Pod™\s*\/\s*30mL/g, "Pro-Pod™")}</span>
			  </div>
			</div>`;
      });
    }

    return string;
  }

  return `
		 <td class="md:w-1/12 pt-7 pb-0 md:pt-5 md:pb-5 col-start-1 col-end-1 align-top">
			 <div class="relative w-full md:w-32 float-left before:h-0 before:block before:pb-[100%]">
				 <a href="${fpUrl}" class="absolute top-0 left-0 disable-effect w-full h-full overflow-hidden bg-[#f5f1ec] rounded-md" aria-label="Item added to your cart" tabindex="-1">
					 <img src="${fpImg}" class="object-cover h-full w-full top-0 left-0 absolute duration-300 image-hover z-0" alt="${fpTitle}" loading="lazy" width="150" height="150">
				 </a>
			 </div>
		 </td>
		 <td class="md:w-5/12 pt-7 pb-0 px-5 md:pt-5 md:pb-5 lg:pl-9 lg:pr-14 col-start-2 col-end-5 md:col-end-4 align-top">
			 <div>
				 <a href="${fpUrl}" class="text-[rgba(var(--colors-heading))] font-bold table disable-effect hover-text-link p-break-words mb-1.5">
					 ${fpTitle}
				 </a>
			 </div>
			 <dl class="text-normal pb-1.5">
			 </dl>
			 <div class="rebuy-cart__flyout-item-properties">
				 ${fpProductsTitleProp(item)}
			 </div>
			 <div class="price mb-1.5 md:hidden">
				 <s class="cap mr-1 rtl:ml-1 rtl:mr-0 inline-block opacity-50 text-[#1a1a1a]">${formatMoney(fpSlashedOutPrice)}</s>
				 <span class="selection:bg-text-[rgb(var(--colors-price-sale),0.2)] text-[#6b2e16] font-semibold">
					 ${formatMoney(fpSalePrice)}
				 </span>
			 </div>
			 <ul class="w-fit p-1 bg-[#6b2e16] lg:mb-0 rounded-md mt-2">
				 <li class="flex text-white relative x-discount items-center gap-2">
					 <span class="leading-none text-normal discount-title">Family plan savings (-${formatMoney(fpOffValue)})</span>
				 </li>
			 </ul>
		 </td>
		 <td class="lg:pl-2 pt-0 pb-5 pl-5 mt-2 md:pr-5 lg:pr-0 md:mt-3.5 md:pl-0 md:pt-5 rtl:pr-5 rtl:md:pr-0 rtl:md:pl-5 rtl:lg:pl-0 col-start-2 col-end-4 flex items-center md:table-cell md:align-top">
			 <div class="x-cart-item-quantity flex justify-center">
				 <div class="flex flex-row md:flex-col items-center gap-2">
					 <div class="relative flex w-28 h-10 border border-solid justify-between rounded-full">
						 <button class="items-center w-1/3 justify-center flex opacity-70 cursor-pointer quantity-selector__button-dec quantity-button-decrease" aria-label="button-minus" data-no-instant="">
							 <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="w-3" fill="none" viewBox="0 0 10 2">
								 <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
							 </svg>
						 </button>
						 <span class="cart-item-qty outer-spin-button bg-transparent w-1/3 text-center pt-2 pb-2 placeholder:opacity-60 focus-within:outline-none quantity-selector__input" aria-label="Quantity for ${fpTitle}">${item.quantity}</span>
						 <button class="items-center w-1/3 justify-center flex opacity-70 cursor-pointer quantity-selector__button-inc quantity-button-increase" aria-label="button-plus" data-no-instant="">
							 <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="w-3" fill="none" viewBox="0 0 10 10">
								 <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
							 </svg>
						 </button>
					 </div>
				 </div>
			 </div>
		 </td>
		 <td class="pb-5 md:pt-5 md:table-cell md:align-top lg:w-2/12 lg:pl-2">
			 <div class="flex justify-end">
				 <div class="price cart-item-price-1 hidden md:flex md:flex-wrap md:flex-col text-right">
					 <s class="cap mr-1 rtl:ml-1 rtl:mr-0 inline-block opacity-50 text-[#1a1a1a]">${formatMoney(fpSlashedOutPrice)}</s>
					 <span class="text-[#6b2e16] font-semibold">${formatMoney(fpSalePrice)}</span>
				 </div>
			 </div>
		 </td>
	`;
}

function fpLineItemMarkup(item) {
  const fpTitle = "Family Plan";
  const fpSlashedOutPrice = item.properties["_fp_slashed_out_price"];
  const fpSalePrice = item.properties["_fp_sale_price"];
  let fpOffValue = item.properties["_fp_off_value"];
  const fpImg = item.properties["_fp_img"];
  const fpUrl = item.properties["_fp_url"];

  function fpProductsTitleProp(item) {
    let string = "";

    if (item.properties["_fq_products"]) {
      item.properties["_fq_products"].forEach((productGroup, index) => {
        string += `
            <div class="rebuy-cart__flyout-item-member">
              <h4>Member ${index + 1}</h4>
              <div class="rebuy-cart__flyout-item-property">
                <span class="rebuy-cart__flyout-item-property-name">Diffuser</span>
                <span class="rebuy-cart__flyout-item-property-separator"> - </span>
                <span class="rebuy-cart__flyout-item-property-value">${productGroup.product_title}</span>
              </div>
              <div class="rebuy-cart__flyout-item-property">
                <span class="rebuy-cart__flyout-item-property-name">Oil</span>
                <span class="rebuy-cart__flyout-item-property-separator"> - </span>
                <span class="rebuy-cart__flyout-item-property-value">${productGroup.addon_title.replace(/Pro-Pod™\s*\/\s*30mL/g, "Pro-Pod™")}</span>
              </div>
            </div>`;
      });
    }

    return string;
  }

  return `
        <div class="rebuy-cart__flyout-item-media">
          <a href="${fpUrl}" tabindex="-1">
            <img src="${fpImg} alt="${fpTitle}"></a>
        </div>
        <div class="rebuy-cart__flyout-item-info">
          <a
            role="heading"
            aria-level="5"
            href="${fpUrl}"
            alt="View ${fpTitle}"
            class="rebuy-cart__flyout-item-product-title">${fpTitle}</a>
          <div class="rebuy-cart__flyout-item-discount-message">Family plan savings ${formatMoney(fpOffValue)}</div>
          <div class="rebuy-cart__flyout-item-properties">
            ${fpProductsTitleProp(item)}
        </div>
          <!---->
          <button
            type="button"
            alt="Remove ${fpTitle}"
            aria-label="Remove ${fpTitle}"
            class="rebuy-cart__flyout-item-remove line-item__remove-button">
            <i aria-hidden="true" class="far fa-trash"></i>
          </button>
          <div class="rebuy-cart__flyout-item-quantity">
            <div class="rebuy-cart__flyout-item-quantity-widget">
              <button
                alt="Decrease quantity of ${fpTitle}"
                aria-label="Decrease quantity of ${fpTitle}"
                type="button"
                class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-decrease quantity-selector__button-dec">
                <i aria-hidden="true" class="far fa-minus"></i>
              </button>
              <span class="rebuy-cart__flyout-item-quantity-widget-label quantity-selector__input">
                ${item.quantity}
              </span>
              <button
                alt="Increase quantity of ${fpTitle}"
                aria-label="Increase quantity of ${fpTitle}"
                type="button"
                class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-increase quantity-selector__button-inc">
                <i aria-hidden="true" class="far fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="rebuy-cart__flyout-item-price">
            <div>
              <span class="rebuy-money sale">
                <span class="sr-only">Sale price</span>
                <span>${formatMoney(fpSalePrice)}</span>
              </span>
              <span class="rebuy-money compare-at">
                <span class="sr-only">Original price</span>
                <span>${formatMoney(fpSlashedOutPrice)}</span>
              </span>
            </div>
            <!---->
          </div>
          <!---->
        </div>
    `;
}

function bundleLineItemMarkupCartPage(item) {
  const bundleCodeProp = item.properties["_bundle_hash"];
  const bundleTitle = item.properties["_bundle_title"];
  const bundleSlashedOutPrice = item.properties["_bundle_slashed_out_price"];
  const bundleSalePrice = item.properties["_bundle_sale_price"];
  let bundleOffValue = item.properties["_bundle_off_value"];
  const bundleImg = item.properties["_bundle_img"];
  const bundleUrl = item.properties["_bundle_url"];
  if (bundleOffValue && bundleOffValue.includes("(")) {
    bundleOffValue = bundleOffValue.split("(")[1].split(")")[0].toUpperCase() + " Sale";
  }

  function bundleProductsTitleProp(item) {
    var string = "";
    for (const [key, value] of Object.entries(item.properties["_bundle_products"])) {
      const formattedKey = "Bundle " + key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ");
      if (key.includes("product") && value) {
        let propertyString = `
        <div class="rebuy-cart__flyout-item-property">
          <span class="rebuy-cart__flyout-item-property-value">${value.replace(/Pro-Pod™\s*\/\s*30mL/g, "Pro-Pod™")}</span>
        </div>
        `;
        string = string.concat(propertyString);
      }
    }
    return string;
  }

  return `
		<td class="md:w-1/12 pt-7 pb-0 md:pt-5 md:pb-5 col-start-1 col-end-1 align-top">
			<div class="relative w-full md:w-32 float-left before:h-0 before:block before:pb-[100%]">
				<a href="${bundleUrl}" class="absolute top-0 left-0 disable-effect w-full h-full overflow-hidden bg-[#f5f1ec] rounded-md" aria-label="Item added to your cart" tabindex="-1">
					<img src="${bundleImg}" class="object-cover h-full w-full top-0 left-0 absolute duration-300 image-hover z-0" alt="${bundleTitle}" loading="lazy" width="150" height="150">
				</a>
			</div>
		</td>
		<td class="md:w-5/12 pt-7 pb-0 px-5 md:pt-5 md:pb-5 lg:pl-9 lg:pr-14 col-start-2 col-end-5 md:col-end-4 align-top">
			<div>
				<a href="${bundleUrl}" class="text-[rgba(var(--colors-heading))] font-bold table disable-effect hover-text-link p-break-words mb-1.5">
					${bundleTitle}
				</a>
			</div>
			<dl class="text-normal pb-1.5">
			</dl>
			<div class="rebuy-cart__flyout-item-properties">
				<span><b>Bundle Products</b></span>
				${bundleProductsTitleProp(item)}
			</div>
			<div class="price mb-1.5 md:hidden">
				<s class="cap mr-1 rtl:ml-1 rtl:mr-0 inline-block opacity-50 text-[#1a1a1a]">${formatMoney(bundleSlashedOutPrice)}</s>
				<span class="selection:bg-text-[rgb(var(--colors-price-sale),0.2)] text-[#6b2e16] font-semibold">
					${formatMoney(bundleSalePrice)}
				</span>
			</div>
			${bundleOffValue ? `
			<ul class="w-fit p-1 bg-[#6b2e16] lg:mb-0 rounded-md mt-2">
				<li class="flex text-white relative x-discount items-center gap-2">
					<span class="leading-none text-normal discount-title">${bundleOffValue}</span>
				</li>
			</ul>
			` : ''}
		</td>
		<td class="lg:pl-2 pt-0 pb-5 pl-5 mt-2 md:pr-5 lg:pr-0 md:mt-3.5 md:pl-0 md:pt-5 rtl:pr-5 rtl:md:pr-0 rtl:md:pl-5 rtl:lg:pl-0 col-start-2 col-end-4 flex items-center md:table-cell md:align-top">
			<div class="x-cart-item-quantity flex justify-center">
				<div class="flex flex-row md:flex-col items-center gap-2">
					<div class="relative flex w-28 h-10 border border-solid justify-between rounded-full">
						<button class="items-center w-1/3 justify-center flex opacity-70 cursor-pointer quantity-selector__button-dec quantity-button-decrease" aria-label="button-minus" data-no-instant="">
							<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="w-3" fill="none" viewBox="0 0 10 2">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
							</svg>
						</button>
						<span class="cart-item-qty outer-spin-button bg-transparent w-1/3 text-center pt-2 pb-2 placeholder:opacity-60 focus-within:outline-none quantity-selector__input" aria-label="Quantity for ${bundleTitle}">${item.quantity}</span>
						<button class="items-center w-1/3 justify-center flex opacity-70 cursor-pointer quantity-selector__button-inc quantity-button-increase" aria-label="button-plus" data-no-instant="">
							<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="w-3" fill="none" viewBox="0 0 10 10">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
							</svg>
						</button>
					</div>
				</div>
			</div>
		</td>
		<td class="pb-5 md:pt-5 md:table-cell md:align-top lg:w-2/12 lg:pl-2">
			<div class="flex justify-end">
				<div class="price cart-item-price-1 hidden md:flex md:flex-wrap md:flex-col text-right">
					<s class="cap mr-1 rtl:ml-1 rtl:mr-0 inline-block opacity-50 text-[#1a1a1a]">${formatMoney(bundleSlashedOutPrice)}</s>
					<span class="text-[#6b2e16] font-semibold">${formatMoney(bundleSalePrice)}</span>
				</div>
			</div>
		</td>
   `;
}

function bundleLineItemMarkup(item) {
  const bundleCodeProp = item.properties["_bundle_hash"];
  const bundleTitle = item.properties["_bundle_title"];
  const bundleSlashedOutPrice = item.properties["_bundle_slashed_out_price"];
  const bundleSalePrice = item.properties["_bundle_sale_price"];
  let bundleOffValue = item.properties["_bundle_off_value"];
  const bundleImg = item.properties["_bundle_img"];
  const bundleUrl = item.properties["_bundle_url"];

  function bundleProductsTitleProp(item) {
    var string = "";
    for (const [key, value] of Object.entries(item.properties["_bundle_products"])) {
      const formattedKey = "Bundle " + key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ");
      if (key.includes("product") && value) {
        let propertyString = `
        <div class="rebuy-cart__flyout-item-property"><span class="rebuy-cart__flyout-item-property-name">${formattedKey}</span> <span class="rebuy-cart__flyout-item-property-separator">
          -
          </span> 
           <span class="rebuy-cart__flyout-item-property-value">${value.replace(/Pro-Pod™\s*\/\s*30mL/g, "Pro-Pod™").replace(/20\s?ml/gi, "One Month Supply")}
            </span>
        </div>
        `;
        string = string.concat(propertyString);
      }
    }
    return string;
  }

  return `
      <div class="rebuy-cart__flyout-item-media">
        <a href="${bundleUrl}" tabindex="-1">
          <img src="${bundleImg} alt="${bundleTitle}"></a>
      </div>
      <div class="rebuy-cart__flyout-item-info">
        <a
          role="heading"
          aria-level="5"
          href="${bundleUrl}"
          alt="View ${bundleTitle}"
          class="rebuy-cart__flyout-item-product-title">${bundleTitle}</a>
        <div class="rebuy-cart__flyout-item-discount-message">${bundleOffValue}</div>
        <div class="rebuy-cart__flyout-item-properties">
        ${bundleProductsTitleProp(item)}
      </div>
        <!---->
        <button
          type="button"
          alt="Remove ${bundleTitle}"
          aria-label="Remove ${bundleTitle}"
          class="rebuy-cart__flyout-item-remove line-item__remove-button">
          <i aria-hidden="true" class="far fa-trash"></i>
        </button>
        <div class="rebuy-cart__flyout-item-quantity">
          <div class="rebuy-cart__flyout-item-quantity-widget">
            <button
              alt="Decrease quantity of ${bundleTitle}"
              aria-label="Decrease quantity of ${bundleTitle}"
              type="button"
              class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-decrease quantity-selector__button-dec">
              <i aria-hidden="true" class="far fa-minus"></i>
            </button>
            <span class="rebuy-cart__flyout-item-quantity-widget-label quantity-selector__input">
              ${item.quantity}
            </span>
            <button
              alt="Increase quantity of ${bundleTitle}"
              aria-label="Increase quantity of ${bundleTitle}"
              type="button"
              class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-increase quantity-selector__button-inc">
              <i aria-hidden="true" class="far fa-plus"></i>
            </button>
          </div>
        </div>
        <div class="rebuy-cart__flyout-item-price">
          <div>
            <span class="rebuy-money sale">
              <span class="sr-only">Sale price</span>
              <span>${bundleSalePrice}</span>
            </span>
            <span class="rebuy-money compare-at">
              <span class="sr-only">Original price</span>
              <span>${bundleSlashedOutPrice}</span>
            </span>
          </div>
          <!---->
        </div>
        <!---->
      </div>
  `;
}

async function getbundleProducts(bundleProp, bundleId) {
  const { items } = await fetchCart();
  let bundleProducts = [];
  items.map((item) => {
    if (item.properties[bundleProp] == bundleId) {
      bundleProducts.push(item);
    }
  });
  return bundleProducts;
}

function updateLineItemWithQty(bundleProducts, bundleQty) {
  return new Promise((resolve, reject) => {
    if (!bundleProducts.length) return resolve();

    const newObj = {};
    bundleProducts.forEach((item) => {
      const perBundleQty = parseInt(item.properties._bundle_qty || 1); // fallback to 1
      newObj[item.key.toString()] = bundleQty * perBundleQty;
    });

    jQuery
      .post(window.Shopify.routes.root + "cart/update.js", {
        updates: newObj,
      })
      .done(() => {
        resolve();
      })
      .fail((error) => {
        console.log(error);
        reject(error);
      });
  });
}

async function attachELToLineItem() {
  let staticLineItems = document.querySelectorAll(".static-line-item");
  for (let i = 0; i < staticLineItems.length; i++) {
    const lineItem = staticLineItems[i];
    let removeBtns = lineItem.querySelectorAll(".line-item__remove-button");
    let qtyIncBtns = lineItem.querySelectorAll(".quantity-selector__button-inc");
    let qtyDecBtns = lineItem.querySelectorAll(".quantity-selector__button-dec");
    let qtyTexts = lineItem.querySelectorAll(".quantity-selector__input");
    let lineBundleId = lineItem.id;
    let bundleProp = lineItem.dataset.type;

    removeBtns.forEach((removeBtn) => {
      if (!removeBtn.hasAttribute("data-listener-attached")) {
        removeBtn.addEventListener("click", async function (event) {
          const bundleProducts = await getbundleProducts(bundleProp, lineBundleId);
          // console.log("click remove", event.target, bundleProp, lineBundleId, bundleProducts);
          try {
            await updateLineItemWithQty(bundleProducts, 0);
            lineItem.remove();
          } catch (error) {
            console.log("Error updating quantity:", error);
          }
        });
        removeBtn.setAttribute("data-listener-attached", "true");
      }
    });

    qtyIncBtns.forEach((qtyIncBtn) => {
      if (!qtyIncBtn.hasAttribute("data-listener-attached")) {
        qtyIncBtn.addEventListener("click", async function (event) {
          const bundleProducts = await getbundleProducts(bundleProp, lineBundleId);
          // console.log("click Inc", event.target, bundleProp, lineBundleId, bundleProducts);
          let qtyTextInt = parseInt(qtyTexts[0].innerText) + 1;

          try {
            await updateLineItemWithQty(bundleProducts, qtyTextInt);
            qtyTexts.forEach((qtyTxt) => {
              qtyTxt.innerText = qtyTextInt;
            });
          } catch (error) {
            console.log("Error updating quantity:", error);
          }
        });
        qtyIncBtn.setAttribute("data-listener-attached", "true");
      }
    });

    qtyDecBtns.forEach((qtyDecBtn) => {
      if (!qtyDecBtn.hasAttribute("data-listener-attached")) {
        qtyDecBtn.addEventListener("click", async function (event) {
          const bundleProducts = await getbundleProducts(bundleProp, lineBundleId);
          // console.log("click dec", event.target, bundleProp, lineBundleId, bundleProducts);
          let qtyTextInt = parseInt(qtyTexts[0].innerText) - 1;

          try {
            await updateLineItemWithQty(bundleProducts, qtyTextInt);
            if (qtyTextInt == 0) {
              lineItem.remove();
            } else {
              qtyTexts.forEach((qtyTxt) => {
                qtyTxt.innerText = qtyTextInt;
              });
            }
          } catch (error) {
            console.log("Error updating quantity:", error);
          }
        });
        qtyDecBtn.setAttribute("data-listener-attached", "true");
      }
    });
  }
}

document.addEventListener("rebuy:smartcart.show", (event) => {
  setTimeout(() => {
    const { items } = Rebuy.Cart.cart;
    if (items.some((item) => item.properties?.["_bundle_id"])) {
      renderStarterKitLineItems();
    }
    if (items.some((item) => item.properties?.["_bundle_set"])) {
      renderBundleSetLineItems();
    }
  }, 1000);
});

const bundleATCBtn = document.querySelector(".bundle-add-to-cart__btn");
if (bundleATCBtn) {
  bundleATCBtn.addEventListener("click", function () {
    setTimeout(async () => {
      await renderBundleLineItems();
    }, 2000);
  });
}

if (isCartPage) {
  (async () => {
    const cart = await fetchCart();
    if (cart.items.some((item) => item.properties?.["_bundle_id"])) {
      await renderStarterKitLineItems();
    }
    if (cart.items.some((item) => item.properties?.["_bundle_hash"])) {
      await renderBundleLineItems();
    }
    if (cart.items.some((item) => item.properties?.["_fp_id"])) {
      await renderFpLineItems();
    }
    if (cart.items.some((item) => item.properties?.["_bundle_set"])) {
      await renderBundleSetLineItems();
    }
  })();
} else {
  document.addEventListener("rebuy:smartcart.ready", async () => {
    const { items } = Rebuy.Cart.cart;
    if (items.length) {
      if (items.some((item) => item.properties?.["_bundle_id"])) {
        await renderStarterKitLineItems();
      }
      if (items.some((item) => item.properties?.["_bundle_set"])) {
        await renderBundleSetLineItems();
      }
      if (items.some((item) => item.properties?.["_bundle_hash"])) {
        await renderBundleLineItems();
      }
      if (items.some((item) => item.properties?.["_fp_id"])) {
        await renderFpLineItems();
      }
    }
  });
}

document.addEventListener("eurus:cart:items-changed", async () => {
  if(!isCartPage) return;
  setTimeout(async () => {
  let items;
  if(window.Rebuy) {
    items = Rebuy.Cart.cart.items;
  } else {
    const cart = await fetchCart();
    items = cart.items;
  }

  if(! items || ! items.length) return;

  if (items.length) {
    if (items.some((item) => item.properties?.["_bundle_id"])) {
      await renderStarterKitLineItems();
    }
    if (items.some((item) => item.properties?.["_bundle_set"])) {
      await renderBundleSetLineItems();
    }
    if (items.some((item) => item.properties?.["_bundle_hash"])) {
      await renderBundleLineItems();
    }
    if (items.some((item) => item.properties?.["_fp_id"])) {
      await renderFpLineItems();
    }
    }
    console.log("cart items changed");
  }, 1000);
});